module.exports = __webpack_public_path__ + "img/dongji_ps_04.b6d446d8.jpg";